"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OpenSourceToolkit() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const heading = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const body = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3678" id="open-source-toolkit" className="bg-background text-foreground relative overflow-hidden py-28 md:py-36 lg:py-44 px-6 md:px-10">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      background: "radial-gradient(circle at 70% 50%, hsla(270, 100%, 64%, 0.15) 0%, transparent 55%)"
    }} />

      <div className="relative mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-8 lg:col-start-2">
            <div ref={eyebrow.ref} className={`mb-10 transition-all duration-700 ease-out ${eyebrow.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <span className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground">RESOURCES</span>
              <div className="mt-4 h-px w-16 bg-border" />
            </div>

            <h2 ref={heading.ref} className={`font-default font-semibold text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight text-foreground transition-all duration-1000 ease-out ${heading.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              Build your
              <br />
              <span className="italic font-light" style={{
              color: "hsl(270 100% 64%)"
            }}>
                future.
              </span>
            </h2>

            <p ref={body.ref} className={`mt-10 max-w-xl text-lg md:text-[18px] leading-relaxed text-muted-foreground transition-all duration-700 delay-150 ease-out ${body.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Access our curated monthly open-source toolkit, packed with the latest frameworks, hardware configurations, and community-tested project blueprints to accelerate your development.
            </p>

            <div ref={ctas.ref} className={`mt-12 flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-4 transition-all duration-700 delay-300 ease-out ${ctas.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Link to="/JoinUsPage">
                <Button size="lg" className="bg-primary text-primary-foreground rounded-lg h-14 px-8 text-base font-medium group">
                  Download Toolkit
                  <ArrowRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Button>
              </Link>

              <Link to="/TheLabPage" className="inline-flex items-center text-base font-medium text-foreground underline underline-offset-8 decoration-1 hover:decoration-2 transition-all px-2">
                Explore The Lab
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-3 lg:col-start-10 flex justify-center lg:justify-end">
            <div ref={image.ref} className={`relative transition-all duration-1000 ease-out ${image.isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
              {}
              <div aria-hidden="true" className="absolute inset-0 -m-6 rounded-lg blur-2xl opacity-40" style={{
              background: "hsl(270 100% 64%)"
            }} />
              <div className="relative w-64 h-64 md:w-80 md:h-80 overflow-hidden shadow-lg" style={{
              borderRadius: "8px"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/coding_setup_terminal.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/coding_setup_terminal.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/coding_setup_terminal.webp-wvc-sizes" alt="A high-tech coding environment with terminal screens and hardware components at Code Hub" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}